import React, { useLayoutEffect, useRef, useState } from 'react';

import { novoPortalUrl, dataDescontinuacao } from '~/config/novoPortal';
import { Container, Icone, Textos, BotaoAcessar, BotaoFechar } from './styles';

const chaveFechado = 'avisoNovoPortalFechado';

// Telas que usam calc(100vh - ...) descontam a altura do aviso por esta variável.
const variavelAltura = '--aviso-novo-portal-altura';

function lerFechado() {
  try {
    return sessionStorage.getItem(chaveFechado) === '1';
  } catch {
    return false;
  }
}

function salvarFechado() {
  try {
    sessionStorage.setItem(chaveFechado, '1');
  } catch {
    // Sem sessionStorage o aviso some só até recarregar a página.
  }
}

function jaDescontinuado() {
  const [ano, mes, dia] = dataDescontinuacao.split('-').map(Number);

  return new Date() >= new Date(ano, mes - 1, dia + 1);
}

export default function AvisoNovoPortal() {
  const [fechado, setFechado] = useState(lerFechado);
  const ref = useRef();

  useLayoutEffect(() => {
    const elemento = ref.current;
    if (!elemento) return undefined;

    const raiz = document.documentElement;
    const atualizar = () => raiz.style.setProperty(variavelAltura, `${elemento.offsetHeight}px`);
    atualizar();

    const observer = window.ResizeObserver ? new ResizeObserver(atualizar) : undefined;
    observer?.observe(elemento);

    return () => {
      observer?.disconnect();
      raiz.style.removeProperty(variavelAltura);
    };
  }, [fechado]);

  if (fechado) return null;

  // Passada a data o aviso continua: se o desligamento atrasar,
  // ele segue sendo o caminho para o novo portal.
  const descontinuado = jaDescontinuado();

  function fechar() {
    salvarFechado();
    setFechado(true);
  }

  return (
    <Container ref={ref} aria-label="Aviso de descontinuação do portal">
      <div className="conteudo">
        <Icone className="material-icons" aria-hidden="true">
          warning
        </Icone>
        <Textos>
          <p className="titulo">Este portal {descontinuado ? 'foi' : 'será'} descontinuado</p>
          <p className="texto">
            Todas as funcionalidades já estão disponíveis no novo portal. Use o mesmo login e senha.
          </p>
        </Textos>
        <BotaoAcessar href={novoPortalUrl} target="_blank" rel="noopener noreferrer">
          Acessar o novo portal
          <i className="material-icons" aria-hidden="true">
            arrow_forward
          </i>
        </BotaoAcessar>
        <BotaoFechar type="button" onClick={fechar} aria-label="Fechar aviso" title="Fechar">
          <i className="material-icons" aria-hidden="true">
            close
          </i>
        </BotaoFechar>
      </div>
    </Container>
  );
}
